import { render, staticRenderFns } from "./DataRight.vue?vue&type=template&id=7120252e&scoped=true"
import script from "./DataRight.vue?vue&type=script&lang=js"
export * from "./DataRight.vue?vue&type=script&lang=js"
import style0 from "./DataRight.vue?vue&type=style&index=0&id=7120252e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120252e",
  null
  
)

export default component.exports